import * as React from 'react'

import clx from 'classnames'
import styles from './style.module.scss'
import { RouteComponentProps } from '@/app/navigation/withRouter'

export * from './AmountsTable'

type RouteParams = {
  companyId: string
  driverId: string
  yearMonth: string // example. "2026-01"
}

export type AmountPageProps = RouteComponentProps<RouteParams>

export function parseProps(props: AmountPageProps) {
  try {
    const { companyId, driverId, yearMonth } = props.match.params
    return { companyId, driverId, yearMonth }
  } catch (e) {
    return { companyId: '', driverId: '', yearMonth: '' }
  }
}

export const drawHeaderRow = (title: string) => (
  <tr className={clx(styles.section)}>
    <th colSpan={5} scope="colgroup">
      {title}
    </th>
  </tr>
)

export const drawSummaryRow = (value: string, title: string = 'Suma', isMainSummary: boolean = false) => (
  <tr className={isMainSummary ? styles.mainSummary : styles.subtotal}>
    <td colSpan={4}>{title}</td>
    <td>{value}</td>
  </tr>
)

export function drawExtendedRow(
  key: string,
  value1: string,
  value2: string,
  value3: string,
  value4: string,
  value5: string,
  bold: boolean = false,
  color: string = '#F8FAFC',
  margin: number = 2,
  isSubfields: boolean = true,
) {
  return (
    <tr
      key={key}
      className={styles.subfields}
      style={{
        // backgroundColor: color,
        fontWeight: bold ? 'bold' : 'inherit',
      }}
    >
      <td>{value1}</td>
      <td>{value2}</td>
      <td>{value3}</td>
      <td>{value4}</td>
      <td>{value5}</td>
    </tr>
  )
}

export function formatNumber(value: any): string {
  return value != null ? parseFloat(value).toFixed(2).toLocaleString() : ''
}
